import {Tooltip, Tab} from 'bootstrap';
import AOS from 'aos';
import CookieNotification from "bb-cookie-notification";
import Flickity from 'flickity';
import axios from 'axios';
import ModuloBox from './plugins/modulobox.js';
import './plugins/gridzy.min.js';
import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';

// Init Animate On Scroll
AOS.init();

// BenedenBoven cookiescript
new CookieNotification();

// Remove background-img border
document.querySelectorAll('img:not([src])').forEach((element) => {
    element.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
});

if(document.querySelector('.tab-nav')) {
    document.querySelectorAll('.tab-nav a').forEach((triggerEl) => {
        const tabTrigger = new Tab(triggerEl);

        triggerEl.addEventListener('click', (event) => {
            event.preventDefault();

            tabTrigger.show();

            const el = document.querySelector('.breadcrumb');
            const y = el.getBoundingClientRect().top + window.pageYOffset - document.querySelector('nav.navbar').scrollHeight;

            window.scrollTo({top: y, behavior: 'smooth'});
        });
    });
}

const initHashtagATags = () => {
    document.querySelectorAll('a[href*="#"]').forEach((el) => {
        el.addEventListener('click', (event) => {

            const targetElement = document.getElementById(
                event.currentTarget.href.replace(/^.*#(.*)$/, '$1')
            );

            if(targetElement && !targetElement.classList.contains('tab-pane')) {
                event.preventDefault();
                const y = targetElement.getBoundingClientRect().top + window.pageYOffset - document.querySelector('nav.navbar').scrollHeight;

                window.scrollTo({ top: y, behavior: 'smooth' });
            }
        });
    });
}

initHashtagATags();

if(location.hash) {
    if(document.querySelector('[href="' + location.hash + '"]')) {
        setTimeout(() => {
            document.querySelector('[href="' + location.hash + '"]').dispatchEvent(
                new Event('click')
            );
        }, 700);
    }
}

document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((tooltipEl) => {
    return new Tooltip(tooltipEl);
})


// Add and remove class on scroll
if(document.querySelector('nav')) {
    let scrollpos      = window.scrollY
    const header       = document.querySelector("nav")
    const headerHeight = header.offsetHeight

    const addClassOnScroll    = () => header.classList.add("navbar-shrink")
    const removeClassOnScroll = () => header.classList.remove("navbar-shrink")

    window.addEventListener('scroll', function() {
        scrollpos = window.scrollY;

        if(scrollpos >= headerHeight) {
            addClassOnScroll()
        } else {
            removeClassOnScroll()
        }
    });
}

if(document.querySelector('.grid')) {
    let grid = document.querySelector('.grid');
    new imagesLoaded(grid, () => {
        const masonry = new Masonry(grid, {
            percentPosition: true
        });
    });
}

if(document.querySelector('.page-body')) {
    document.querySelectorAll('.page-body').forEach((item) => {
        item.querySelectorAll('img').forEach((image) => {
            image.classList.add('img-fluid');

            if(image.style.float === 'right') {
                image.style.marginLeft   = '15px';
                image.style.marginBottom = '15px';
                image.style.marginRight  = '0';
            } else if(image.style.float === 'left') {
                image.style.marginRight  = '15px';
                image.style.marginBottom = '15px';
                image.style.marginLeft   = '0';
            }
        });

        item.querySelectorAll('table').forEach((table) => {
            table.classList.add('table');
            table.border = 0;

            if(!table.parentNode.classList.contains('table-responsive')) {
                let wrapper       = document.createElement('div');
                wrapper.className = 'table-responsive';

                table.parentNode.insertBefore(wrapper, table);
                wrapper.appendChild(table);
            }

            table.querySelectorAll('tr').forEach((tr) => {
                tr.style.height = 'auto';
            });

            table.querySelectorAll('td').forEach((td) => {
                td.style.height = 'auto';
            });

            table.querySelectorAll('p').forEach((p) => {
                p.style.marginBottom = 0;
            });
        });

        item.querySelectorAll('iframe').forEach((iframe) => {
            if(iframe.src.match(/youtube|youtu/)) {
                if(!iframe.parentNode.classList.contains('ratio')) {
                    let wrapper       = document.createElement('div');
                    wrapper.className = 'ratio ratio-16x9';

                    iframe.parentNode.insertBefore(wrapper, iframe);
                    wrapper.appendChild(iframe);
                }
            }
        });
    });
}

if(document.querySelector('.project-btn.close')) {
    document.querySelector('.project-btn.close').addEventListener('click', (event) => {
        event.preventDefault();
        const projectSticky = document.querySelector('.project-sticky');

        if(!projectSticky.classList.contains('out-of-view')) {
            projectSticky.style.right = '-' + 525 + 'px';
            projectSticky.querySelector('.close i').classList.remove('fa-times');
            projectSticky.querySelector('.close i').classList.add('fa-chevron-left');
            projectSticky.querySelector('.close').style.right = 525 + 'px';
        } else {
            projectSticky.style.right = '25px';
            projectSticky.querySelector('.close i').classList.remove('fa-chevron-left');
            projectSticky.querySelector('.close i').classList.add('fa-times');
            projectSticky.querySelector('.close').style.right = '-10px';
        }

        projectSticky.classList.toggle('out-of-view');
    });
}

// Modulobox
const modulobox = new ModuloBox({
    mediaSelector:      '.gallery figure > a, .hidden-gallery div, .page-body :not(a) > img',
    loop:               3,
    history:            true,
    controls:           ['zoom', 'play', 'fullScreen', 'download', 'share', 'close'],
    shareButtons:       ['facebook', 'googleplus', 'twitter', 'pinterest', 'linkedin', 'reddit', 'stumbleupon', 'tumblr', 'blogger', 'buffer', 'digg', 'evernote'],
    videoMaxWidth:      1440,
    minZoom:            1,
    zoomTo:             1.8,
    mouseWheel:         false,
    contextMenu:        false,
    scrollToZoom:       true,
    captionSmallDevice: false,
    thumbnails:         true,
    thumbnailsNav:      'centered',
    thumbnailSizes:     {
        1920: {
            width:  110,
            height: 80,
            gutter: 10
        },
        1280: {
            width:  90,
            height: 65,
            gutter: 10
        },
        680:  {
            width:  0,
            height: 0,
            gutter: 0
        }
    }
});

modulobox.on('beforeOpen.modulobox', function(gallery, index) {
    if(window.cubeRAF) {
        cancelAnimationFrame(window.cubeRAF);
        window.cubeRAF = false;
    }
});

modulobox.on('afterClose.modulobox', function(gallery, index) {
    if(typeof Event === 'function' && !window.cubeRAF) {
        window.dispatchEvent(new Event('scroll'));
    }
});

modulobox.init();

if (document.querySelector('.solutions-carousel')) {
    const flkty = new Flickity('.solutions-carousel', {
        cellAlign: 'left',
        contain: true,
        prevNextButtons: true,
        pageDots: false,
        freeScroll: true,
        groupCells: true
    });
}

if(document.querySelector('.headline-carousel')) {
    new Flickity('.headline-carousel', {
        contain: true,
        freeScroll: true,
        pageDots: false,
        prevNextButtons: true,
        groupCells: true
    })
}

const submitForm = (gRecaptchaResponse) => {
    const form = document.getElementById('form');

    const submitButton = form.querySelector('[type="submit"]');
    submitButton.classList.add('disabled');
    submitButton.disabled  = true;
    submitButton.innerHTML = '<div class="spinner-border spinner-border-sm" role="status"><span class="visually-hidden">Laden...</span></div>';

    const formData = new FormData(form);
    formData.append('g-recaptcha-response', gRecaptchaResponse);

    const validationAlert = document.getElementById('form-validation');
    validationAlert.classList.add('d-none');
    validationAlert.classList.remove('alert-danger');

    document.querySelectorAll('.invalid-feedback').forEach((element) => {
        if(!element.classList.contains('d-none')) {
            element.classList.add('d-none');
        }
    });

    document.querySelectorAll('.is-invalid').forEach((element) => {
        element.classList.remove('is-invalid');
    });

    axios.post(window.location.href, formData).then((response) => {
        if(response.data.success) {
            validationAlert.innerHTML = response.data.message;
            validationAlert.classList.add('alert-success');
            validationAlert.classList.remove('d-none');

            form.innerHTML = '';
        }
    }).catch((exception) => {
        if(exception.response.data.errors) {
            for(let error in exception.response.data.errors) {
                const el = form.querySelector('[name="' + error + '"]') || form.querySelector('#' + error);
                el.classList.add('is-invalid');
                if(el.parentNode.querySelector('.d-none') !== null) {
                    el.parentNode.querySelector('.d-none').classList.remove('d-none');
                }
            }
        }

        submitButton.classList.remove('disabled');
        submitButton.disabled  = false;
        submitButton.innerHTML = 'Verstuur bericht';
    });
}

window.submitForm = submitForm;

if(document.querySelector('.scroll-btns')) {
    const intersectionObserver = new IntersectionObserver(function(entries) {
        if(entries[0].intersectionRatio <= 0) {
            document.querySelector('nav.navbar').insertAdjacentHTML('beforeend', '<div class="sub-btns" style="position:absolute; width:100%; left:0; bottom:-35px; height:35px; white-space: nowrap; z-index:-1; transform:scaleY(0); transition:all 0.3s ease;"><div class="container"><div class="row"><div class="col-12">' + Array.from(document.querySelectorAll('.scroll-btns .btn')).map((el) => el.outerHTML).join('') + '</div></div></div></div>')
            document.querySelectorAll('.sub-btns .btn').forEach((el, i) => {
                if(i === 0) {
                    el.classList.add('active');
                }
                el.classList.remove('btn-primary');
                el.classList.add('btn-really-dark');
                el.style.borderRadius = '0 0 10px 10px';
            });
            setTimeout(() => {
                document.querySelector('.sub-btns').style.transform = 'scaleY(1)';
                initHashtagATags()
            }, 200);
        } else {
            if(document.querySelector('.sub-btns') ) {
                document.querySelector('.sub-btns').remove();
            }
        }
    });
    intersectionObserver.observe(document.querySelector('.scroll-btns'), {rootMargin: "0px 0px -120px 0px"});

    initHashtagATags()
}

if(document.querySelector('.process-item')) {
    const getMostVisibleElement = (elements) => {

        var viewportHeight = window.innerHeight

        var max = 0
        var mostVisibleEl = null

        for (var el of Array.from(elements)) {

            var rect = el.getBoundingClientRect()
            var height = rect.bottom - rect.top
            var visible = {
                top: rect.top >= 0 && rect.top < viewportHeight,
                bottom: rect.bottom > 0 && rect.bottom < viewportHeight
            }

            var visiblePx = 0
            if ( visible.top && visible.bottom ) {
                visiblePx = height // Whole element is visible
            } else if ( visible.top ) {
                visiblePx = viewportHeight - rect.top
            } else if ( visible.bottom ) {
                visiblePx = rect.bottom
            } else if ( height > viewportHeight && rect.top < 0 ) {
                var absTop = Math.abs( rect.top )
                if ( absTop < height ) {
                    visiblePx = height - absTop // Part of the element is visible
                }
            }

            if ( visiblePx > max ) {
                max = visiblePx
                mostVisibleEl = el
            }

        }

        return mostVisibleEl;
    }

    const scrollElements = document.querySelectorAll('.process-item .img-cover');
    window.addEventListener('scroll', (event) => {
        const mostVisibleElement = getMostVisibleElement(scrollElements);
        if(mostVisibleElement !== null && mostVisibleElement.classList.contains('img-grayscale')) {
            mostVisibleElement.classList.remove('img-grayscale');
            if(mostVisibleElement.parentNode.parentNode.parentNode && mostVisibleElement.parentNode.parentNode.parentNode.id) {
                if(document.querySelector('.sub-btns a[href="#' + mostVisibleElement.parentNode.parentNode.parentNode.id + '"]')) {
                    document.querySelectorAll('.sub-btns a').forEach((el) => el.classList.remove('active'));
                    document.querySelector('.sub-btns a[href="#' + mostVisibleElement.parentNode.parentNode.parentNode.id + '"]').classList.add('active');
                }
            }
            scrollElements.forEach((element) => {
                if(element !== mostVisibleElement) {
                    element.classList.add('img-grayscale');
                }
            });
        }
    });

    window.dispatchEvent(
        new Event('scroll')
    );
}
